import { useHistory } from "react-router-dom";
import BoxContent from "../BoxContent";
import "./count-preview.scss";
import { Routes } from "../../../AppRoutes";
import { useLandingStatistic } from "../../procedure/dashboard/hooks/use-landing-statistic";

const CountPreview = (props: any) => {
  const {
    countMyFinishRequests,
    countMyWaitingRequests,
    countMyExpiredRequests,
    countMyApproveWaitingRequests,
    countMyApproveExpiredRequests,
  } = useLandingStatistic();

  const history = useHistory();

  return (
    <div className="count-preview">
      <BoxContent
        color="success"
        background="bg-user"
        onClick={() => history.push({ pathname: Routes.details.path, search: "requests=my-finished" })}
      >
        <BoxContent.Icon src="/assets/images/approved.png" />
        <BoxContent.Right>
          <BoxContent.Label>Đã hoàn tất</BoxContent.Label>
          <BoxContent.Count value={countMyFinishRequests} />
        </BoxContent.Right>
      </BoxContent>

      <BoxContent
        color="info"
        background="bg-user"
        onClick={() => history.push({ pathname: Routes.details.path, search: "requests=my-waiting" })}
      >
        <BoxContent.Icon src="/assets/images/office.png" />
        <BoxContent.Right>
          <BoxContent.Label>Đang xử lý</BoxContent.Label>
          <BoxContent.Count value={countMyWaitingRequests} />
        </BoxContent.Right>
      </BoxContent>

      <BoxContent
        color="danger"
        background="bg-user"
        style={{ width: "100%" }}
        onClick={() => history.push({ pathname: Routes.details.path, search: "requests=my-expired" })}
      >
        <BoxContent.Icon src="/assets/images/stopwatch.png" />
        <BoxContent.Right>
          <BoxContent.Label>Quá hạn</BoxContent.Label>
          <BoxContent.Count value={countMyExpiredRequests} />
        </BoxContent.Right>
      </BoxContent>
      <BoxContent
        color="primary"
        background="bg-approver"
        onClick={() => history.push({ pathname: Routes.details.path, search: "requests=approve-waiting" })}
      >
        <BoxContent.Icon src="/assets/images/teamwork.png" />
        <BoxContent.Right>
          <BoxContent.Label>Cần xử lý</BoxContent.Label>
          <BoxContent.Count value={countMyApproveWaitingRequests} />
        </BoxContent.Right>
      </BoxContent>

      <BoxContent
        color="warning"
        background="bg-approver"
        onClick={() => history.push({ pathname: Routes.details.path, search: "requests=approve-expired" })}
      >
        <BoxContent.Icon src="/assets/images/timer.png" />
        <BoxContent.Right>
          <BoxContent.Label>Trễ hạn</BoxContent.Label>
          <BoxContent.Count value={countMyApproveExpiredRequests} />
        </BoxContent.Right>
      </BoxContent>
    </div>
  );
};

export default CountPreview;
